const DemoPdf = () => {
  const dataArray = [
    {
      type: 'image-text',
      content: '/images/home/f-3.webp',
      heading: 'Ideate',
      icon: 'Idea',
      desc: 'Join our AI incubator to spark and mature your revolutionary AI idea into a viable venture.',
      values: [
        {
          heading: 'Explore AI Domains',
          desc: 'Investigate various AI domains to find a niche that aligns with your passion and market needs.',
        },
        {
          heading: 'Problem-Solution Fit',
          desc: 'Identify a significant problem and articulate how your AI solution addresses it uniquely.',
        },
        {
          heading: 'Viability & Impact',
          desc: 'Consider the commercial viability and potential impact of your idea on society or industry.',
        },
      ],
    },
    {
      type: 'text-image',
      content: '/images/home/f-5.webp',
      heading: 'The Pitch',
      icon: 'PowerPitch',
      desc: 'Craft a pitch that not only sells your AI project but also tells your compelling story.',
      values: [
        {
          heading: 'Clear Value Proposition',
          desc: 'Articulate the unique value your AI project brings and why it’s a game-changer.',
        },
        {
          heading: 'Market Analysis',
          desc: 'Demonstrate a deep understanding of your target market and how your AI fits into it.',
        },
        {
          heading: 'Engaging Presentation',
          desc: "Develop a presentation style that's engaging and confident. Use visuals and storytelling to create a memorable experience for your audience.",
        },
      ],
    },
    {
      type: 'image-text',
      content: '/images/home/f-6.webp',
      heading: 'Know Your Rivals',
      icon: 'RivalIcon',
      desc: 'Conduct thorough research to understand the competitive landscape and position your AI venture effectively.',
      values: [
        {
          heading: 'Competitive Analysis',
          desc: 'Map out key competitors and analyze their strengths, weaknesses, opportunities, and threats.',
        },
        {
          heading: 'Differentiation Strategy',
          desc: 'Identify what sets your AI project apart and how you can leverage this to capture market share.',
        },
        {
          heading: 'Market Positioning',
          desc: 'Strategically position your AI solution in the marketplace to fill gaps left by competitors.',
        },
      ],
    },
  ]

  return (
    <div className="flex flex-col gap-16 max-w-7xl items-center mx-auto mt-20 px-6 lg:px-4 w-full">
      {dataArray.map((item, index) => {
        const isImageText = item.type === 'image-text'
        return (
          <div
            key={index}
            className={`flex ${
              isImageText
                ? 'lg:flex-row flex-col'
                : 'lg:flex-row-reverse flex-col'
            } items-center mb-4 w-full  xl:justify-between xl:gap-20`}
          >
            <img
              src={item.content}
              alt={`Content ${index}`}
              className=" lg:w-[420px] lg:h-[450px] xl:w-[525px] xl:h-[571px] object-cover relative rounded-xl contain border border-[#D0D5DD]"
            />

            <div className="flex items-start text-left gap-8 flex-col h-full px-4 mt-1 sm:mt-0">
              <div className="w-full gap-4 flex-col justify-start items-start flex">
                <item.icon />
                <h1 className="text-white text-3xl font-semibold  leading-[38px]">
                  {item.heading}
                </h1>
                <p className="xl:w-[608px] text-[#D0D5DD] text-xl font-normal leading-7 mt-1 sm:mt-0">
                  {item.desc}
                </p>
              </div>
              <div className="flex flex-col gap-5 ">
                {item.values.map((content, index) => (
                  <div
                    className="justify-start items-start gap-4 inline-flex mt-3 sm:mt-0"
                    key={index}
                  >
                    <div className="w-5 h-5 relative">
                      <div className="w-5 h-5 left-0 top-0 absolute bg-blue-600 rounded-full" />
                      <div className="w-2.5 h-2.5 left-[5px] top-[5px] absolute bg-white rounded-full" />
                    </div>
                    <div className=" ml-4 sm:ml-0 flex-col justify-start items-start gap-1.5 inline-flex">
                      <h1 className="self-stretch sm:h-7 text-white text-xl font-semibold   leading-snug">
                        {content.heading}
                      </h1>
                      <p className="w-full lg:w-[450px] xl:w-[565px] text-[#D0D5DD] text-base font-normal  leading-normal">
                        {content.desc}
                      </p>
                    </div>
                  </div>
                ))}
              </div>
              <div className="flex gap-6">
                {/* <button
                  className="lg:w-[139px] h-11 px-4 py-2.5 bg-blue-600 rounded-lg shadow justify-center items-center gap-3 inline-flex
                            text-white text-base font-medium  leading-normal"
                >
                  <PdfRead /> Read Pdf
                </button> */}
                {/* <button
                  className="lg:w-[191px] h-11 px-4 py-2.5 bg-blue-600 rounded-lg shadow justify-center items-center gap-3 inline-flex
                            text-white text-base font-medium  leading-normal"
                >
                  <AiFillPlayCircle className="w-5 h-5 relative text-white" />
                  Watch the Demo
                </button> */}
              </div>
            </div>
          </div>
        )
      })}
    </div>
  )
}

export default DemoPdf
